import { UserService } from "@/services";
import { mapActions, mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "security-user-name",
  data() {
    return {
      usernameInput: "",
      usernameModal: false,
      isNCFocus: false,
      isNCHover: false,
      isRequesting: false
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.userInfo.getters.GET_USER_INFO
    }),

    username() {
      return this.userInfo?.username;
    },

    canUpdate() {
      return !this.userInfo?.is_username_updated;
    },

    nCNameClass() {
      if (this.isNCFocus) {
        return "mobile_name_focus";
      } else {
        if (!this.isNCValid) {
          return "mobile_name_error";
        } else {
          if (this.usernameInput) {
            return "mobile_name_fill";
          } else {
            if (this.isNCHover) {
              return "mobile_name_empty_hover";
            } else {
              return "mobile_name_empty";
            }
          }
        }
      }
    },
    isNCValid() {
      if (this.usernameInput) {
        const nCRegex = /^\w{4,32}$/;
        return nCRegex.test(this.usernameInput);
      }
      return true;
    }
  },
  methods: {
    ...mapActions({
      setUserName: types.userInfo.actions.SET_USERNAME
    }),

    startRequest() {
      this.isRequesting = true;
    },

    finishRequest() {
      this.isRequesting = false;
    },

    openUsernameModal() {
      this.usernameModal = true;
    },

    closeUsernameModal() {
      this.usernameModal = false;
    },

    updateUsername() {
      if (this.isNCValid && this.canUpdate && this.usernameInput) {
        UserService.updateUsername(this.usernameInput)
          .then(res => {
            this.setUserName(this.usernameInput);
            this.$toast.success(res.data.message);
            this.usernameModal = false;
          })
          .finally(() => this.finishRequest());
        this.startRequest();
      }
    },
    setNCHover(bool) {
      this.isNCHover = bool;
    },

    toggleNCFocus() {
      this.isNCFocus = !this.isNCFocus;
    }
  }
};
